import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function MobileRedirect({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkDevice = () => {
      // Check for mobile devices and tablets
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      // Check for small viewport (tablets and mobile)
      const isSmallViewport = window.innerWidth <= 1024;
      
      const shouldRedirect = isMobileDevice || isSmallViewport;
      
      // Only redirect if we're on the root path and should redirect
      if (shouldRedirect && location.pathname === '/') {
        navigate('/mobile-home', { replace: true });
      }
      // If desktop user is on mobile-home, redirect to root
      else if (!shouldRedirect && location.pathname === '/mobile-home') {
        navigate('/', { replace: true });
      }
    };

    checkDevice();
    
    // Also check on resize
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, [navigate, location.pathname]);

  return children;
}

export default MobileRedirect;

